webpackJsonp([18,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _shared = __webpack_require__(12);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _utils = __webpack_require__(4);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _loginManager = __webpack_require__(276);
	
	var _loginManager2 = _interopRequireDefault(_loginManager);
	
	var _storageController = __webpack_require__(246);
	
	var _storageController2 = _interopRequireDefault(_storageController);
	
	var _formValidator = __webpack_require__(75);
	
	var _formValidator2 = _interopRequireDefault(_formValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 08/05/2017.
	 */
	//js
	var log = __webpack_require__(7)();
	
	
	//Styles
	__webpack_require__(783);
	
	$(function () {
	  _shared2.default.init();
	  LoginPage.init();
	});
	
	var LoginPage = {};
	
	(function (LoginPage) {
	  var $loginForm = void 0;
	
	  var loginFormValidator = null;
	
	  LoginPage.init = function () {
	    setUpEventListeners();
	    setUpLoginForm();
	
	    $loginForm = $("#login-form2");
	  };
	
	  function setUpEventListeners() {
	    $("#authenticate-btn").on("click", function (e) {
	      var $this = $(this);
	      var isValid = loginFormValidator.validate();
	
	      if (isValid) {
	        $this.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");
	
	        login().finally(function () {
	          $this.prop("disabled", false).removeClass("btn-loading");
	        });
	      }
	    });
	
	    var $usernameInput = $("#login-username-input");
	
	    $usernameInput.off("input").on("input", function (e) {
	      $(this).removeClass("input-error");
	    });
	
	    var $passwordInput = $("#login-password-input");
	
	    $passwordInput.off("input").on("input", function (e) {
	      $(this).removeClass("input-error");
	    });
	
	    $passwordInput.off("keyup").on("keyup", function (e) {
	      if (_utils2.default.isNotNull(e.code) && e.code === "Enter" || e.keyCode === 13) {
	        $(this).blur();
	        login();
	      }
	    });
	
	    $("form").off("keypress").on("keypress", function (e) {
	      if (_utils2.default.isNotNull(e.code) && e.code === "Enter" || e.keyCode === 13) {
	        e.preventDefault();
	      }
	    });
	  }
	
	  function setUpLoginForm() {
	    loginFormValidator = new _formValidator2.default({
	      selector: "#login-form2",
	      validateOnChange: true,
	      rules: {
	        username: {
	          validator: function validator(username) {
	            return !_utils2.default.isNullOrEmpty(username) && username.trim() !== "";
	          }
	        },
	        password: {
	          validator: function validator(password) {
	            return !_utils2.default.isNullOrEmpty(password) && password.trim() !== "";
	          }
	        }
	      }
	    });
	  }
	
	  function login() {
	    if (_utils2.default.isNull(loginFormValidator)) return;
	
	    var $formFeedback = $loginForm.find(".form-feedback").empty();
	
	    var formData = loginFormValidator.getFormData();
	
	    var username = formData.username,
	        password = formData.password;
	
	    return _loginManager2.default.login(username, password).then(function (data) {
	      var loginData = data.loginData,
	          referer = data.referer;
	
	      _storageController2.default.saveToLocal(_storageController2.default.keys.LOGGED_IN_USER, loginData);
	
	      log.info("Referer: %s", referer);
	
	      if (!_utils2.default.isNullOrEmpty(referer) && referer.includes("/login")) {
	        _utils2.default.redirect("/teacher/sessions");
	      } else {
	        _utils2.default.redirect(referer);
	      }
	    }).catch(function (appError) {
	      log.error("Login failed - %o", appError);
	
	      loginFormValidator.setValid("password", false);
	      $("#login-password-input").focus();
	
	      if (appError.data.errorType === _loginManager2.default.ERRORS.USERNAME_PASSWORD_INCORRECT) {
	        $formFeedback.text(_languageManager2.default.getValueForKey("login.errors.password_incorrect"));
	      } else {
	        $formFeedback.text(_languageManager2.default.getValueForKey("login.errors.unexpected"));
	      }
	    });
	  }
	})(LoginPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./bs-BA.json": 18,
		"./cs-CZ.json": 19,
		"./de-DE.json": 20,
		"./el-GR.json": 21,
		"./en-GB.json": 22,
		"./es-ES.json": 23,
		"./et-EE.json": 24,
		"./fi-FI.json": 25,
		"./fr-FR.json": 26,
		"./hr-HR.json": 27,
		"./hu-HU.json": 28,
		"./it-IT.json": 29,
		"./ja-JP.json": 30,
		"./lv-LV.json": 31,
		"./nl-BE.json": 32,
		"./pl-PL.json": 33,
		"./pt-PT.json": 34,
		"./sk-SK.json": 35,
		"./sl-SI.json": 36,
		"./sr-RS.json": 37,
		"./sv-SE.json": 38
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 17;


/***/ }),

/***/ 783:
372

});


// WEBPACK FOOTER //
// js/login.05fe255fbdfaa0dd5fa1.js